<template>
  <g>
    <path
      d="M21.65 7.65027L18.86 4.86027C18.54 4.54027 18 4.76027 18 5.21027V7.00027H4C3.45 7.00027 3 7.45027 3 8.00027C3 8.55027 3.45 9.00027 4 9.00027H18V10.7903C18 11.2403 18.54 11.4603 18.85 11.1403L21.64 8.35027C21.84 8.16027 21.84 7.84027 21.65 7.65027Z"
    />
    <path
      d="M2.35001 16.3503L5.14001 19.1403C5.46001 19.4603 6.00001 19.2403 6.00001 18.7903V17.0003H20C20.55 17.0003 21 16.5503 21 16.0003C21 15.4503 20.55 15.0003 20 15.0003H6.00001V13.2103C6.00001 12.7603 5.46001 12.5403 5.15001 12.8603L2.36001 15.6503C2.16001 15.8403 2.16001 16.1603 2.35001 16.3503Z"
    />
  </g>
</template>
